import { useEffect, useState } from "react";
import { Eye, Ban } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { CategoryBadge, StatusBadge } from "@/components/Badges";
import { TaskVerifyDialog } from "@/components/TaskVerifyDialog";
import { api, fmtDateTime, formatErr } from "@/lib/api";

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [tab, setTab] = useState("open");
  const [view, setView] = useState(null);
  const load = () => api.get("/tasks", { params: tab === "all" ? {} : { status: tab } }).then((r) => setTasks(r.data));
  useEffect(() => {
    load();
  }, [tab]); // eslint-disable-line react-hooks/exhaustive-deps

  const cancel = async (t) => {
    try {
      await api.patch(`/tasks/${t.id}/status`, { status: "cancelled" });
      toast.success("Task cancelled");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };

  return (
    <div className="space-y-5">
      <h1 className="font-heading text-4xl font-extrabold text-slate-900 tracking-tight">Tasks &amp; Service Tickets</h1>
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="open" data-testid="tasks-tab-open">Open</TabsTrigger>
          <TabsTrigger value="completed" data-testid="tasks-tab-completed">Completed</TabsTrigger>
          <TabsTrigger value="all" data-testid="tasks-tab-all">All</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="bg-white border rounded-2xl overflow-x-auto">
        <Table>
          <TableHeader><TableRow className="bg-slate-50">
            <TableHead>Task</TableHead><TableHead>Hospital</TableHead><TableHead>Engineer</TableHead><TableHead>Due</TableHead><TableHead>Status</TableHead><TableHead />
          </TableRow></TableHeader>
          <TableBody>
            {tasks.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-10">No tasks.</TableCell></TableRow>}
            {tasks.map((t) => (
              <TableRow key={t.id} data-testid={`admin-task-row-${t.id}`}>
                <TableCell><div className="font-semibold">{t.task_title}</div><CategoryBadge category={t.category} /></TableCell>
                <TableCell className="text-sm">{t.client?.hospital_name}</TableCell>
                <TableCell className="text-sm">{t.assignee_name}</TableCell>
                <TableCell className="text-xs text-slate-600">{fmtDateTime(t.due_date)}</TableCell>
                <TableCell><StatusBadge status={t.status} /></TableCell>
                <TableCell className="text-right whitespace-nowrap">
                  {t.status === "completed" && <Button size="sm" variant="outline" onClick={() => setView(t)} data-testid={`admin-verify-task-${t.id}`}><Eye className="h-4 w-4 mr-1" />Verify</Button>}
                  {["assigned", "in_progress", "pending_spares"].includes(t.status) && (
                    <Button size="sm" variant="ghost" className="text-rose-600" onClick={() => cancel(t)} data-testid={`admin-cancel-task-${t.id}`}><Ban className="h-4 w-4 mr-1" />Cancel</Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <TaskVerifyDialog task={view} onOpenChange={() => setView(null)} />
    </div>
  );
}
